import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const FoodDrink: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG fill="none" {...props}>
            <g clipPath="url(#clip0_507_302)">
                <IconPath
                    d="M2.95889 4.01599L21.0479 22.105M5.08089 1.89999L9.14589 5.96099C9.70641 6.52478 10.021 7.28748 10.021 8.08249C10.021 8.8775 9.70641 9.64021 9.14589 10.204C8.58215 10.7642 7.81966 11.0786 7.02489 11.0786C6.23012 11.0786 5.46763 10.7642 4.90389 10.204L0.837891 6.13799M15.9499 10.204L4.04789 22.105M15.9499 10.204C18.4248 12.6789 20.899 10.2037 20.899 10.2037L22.1364 8.96624C24.6113 6.49137 22.1364 4.0165 22.1364 4.0165C19.6616 1.54162 17.1867 4.0165 17.1867 4.0165L15.9493 5.25393C13.4744 7.72881 15.9499 10.204 15.9499 10.204Z"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_302">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
